/* eslint-disable quotes */
/* eslint-disable max-len */
export const LEGAL_REACCEPTANCE_INTRO_HEADING = 'A quick update before you continue';

export const LEGAL_REACCEPTANCE_INTRO_BODY =
  "We've upgraded our payments system to bring you faster, more reliable payouts. We need two things from you — takes about two minutes.";

export const LEGAL_REACCEPTANCE_INTRO_STEP_1_TITLE = 'Review & accept updated agreements';

export const LEGAL_REACCEPTANCE_INTRO_STEP_1_SUB = 'Terms of Service, E-SIGN Disclosure, and ACH Authorization';

export const LEGAL_REACCEPTANCE_INTRO_STEP_2_TITLE = 'Re-enter your bank account';

export const LEGAL_REACCEPTANCE_INTRO_STEP_2_SUB = 'A one-time step required by our new banking partner';

export const LEGAL_REACCEPTANCE_INTRO_CTA = 'Get started';

/** Terms step (wallet reacceptance wizard): shorter body + CTA when user will continue to bank re-entry. */
export const LEGAL_REACCEPTANCE_TERMS_WALLET_WIZARD_BODY =
  "We've partnered with a new bank to power your payouts — bringing you faster, more reliable payments.";

export const LEGAL_REACCEPTANCE_TERMS_WALLET_WIZARD_CONFIRM_CTA = 'Accept and continue';

export const WALLET_BANK_INSTRUCTION =
  'As part of our new banking partnership, please re-enter your bank details directly. This is a one-time step.';

export const WALLET_BANK_CHECKING_ONLY_LABEL = 'Checking accounts only';

export const WALLET_BANK_ROUTING_HELPER = 'Use your 9-digit ACH routing number, not the wire transfer number.';

export const WALLET_BANK_PLACEHOLDER_ACCOUNT_HOLDER = 'Enter account holder name';

export const WALLET_BANK_PLACEHOLDER_ROUTING = 'ACH routing number (not wire)';

export const WALLET_BANK_PLACEHOLDER_ACCOUNT = 'Enter account number';

export const WALLET_BANK_CONFIRM_CTA = 'Confirm and continue';

export const WALLET_BANK_SKIP_CTA = 'Skip and finish later';

/** Max total impressions of WalletBankAccountScreen (full wizard bank step + bank-only reminders). */
export const MAX_WALLET_BANK_SCREEN_VIEWS = 10;

export const LEGAL_REACCEPTANCE_SUCCESS_TITLE = "You're all set";

export const LEGAL_REACCEPTANCE_SUCCESS_BODY =
  'Your account has been updated. Payouts will now be processed through our new banking partner — faster and more reliably.';

export const LEGAL_REACCEPTANCE_SUCCESS_WHATS_NEXT_TITLE = "What's next";

export const LEGAL_REACCEPTANCE_SUCCESS_WHATS_NEXT_BODY =
  'Your next payout will go directly to the bank account you just connected.';

export const LEGAL_REACCEPTANCE_SUCCESS_CTA = 'Back to ScanPay';
